import { useEffect, useState } from "react";
import "./TestimonialsPage.scss";
import TestimonialCard from "../../components/reviews/TestimonialCard";
import TestimonyForm from "../../components/reviews/TestimonyForm";
import axios from "../../api/axios";

export default function TestimonialsPage() {
    const [testimonials, setTestimonials] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const res = await axios.get("/v/testimonials/verified");
                setTestimonials(res.data);
            } catch (err) {
                console.error(err);
                setTestimonials([]);
            }
            setLoading(false);
        };

        fetchReviews();
    }, []);

    return (
        <div className="bodyWrapper">
            <section className="curved"></section>

            <div className="testimony-page">

                {/* TOP ROW: QR + FORM */}
                <div className="responsive-cards">

                    {/* QR BOX */}
                    <div className="card qr-card">
                        <h3>
                            If you would like to leave a testimony on Google, you can
                            scan the QR Code or click the link below:
                        </h3>

                        <div className="qr-content">
                            <img
                                src="https://api.qrserver.com/v1/create-qr-code/?size=230x230&data=https%3A%2F%2Fsearch.google.com%2Flocal%2Fwritereview%3Fplaceid%3DChIJG_nktywDdkgRe4j8jlLrfd8%26source%3Dg.page.m._%26laa%3Dmerchant-review-solicitation"
                                alt="QR Code to leave a Google Review"
                                className="qr-image"
                            />

                            <a
                                className="google-link"
                                href="https://search.google.com/local/writereview?placeid=ChIJG_nktywDdkgRe4j8jlLrfd8&source=g.page.m._&laa=merchant-review-solicitation"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Click here to leave a testimony on Google
                            </a>
                        </div>
                    </div>

                    {/* FORM CARD */}
                    <div className="card form-card">
                        <TestimonyForm />
                    </div>
                </div>

                {/* SECTION HEADER */}
                <div className="section-heading">
                    <h1>Read what our customers say</h1>
                    <p className="section-subheading">
                        Real reviews from real customers
                    </p>
                </div>

                {/* TESTIMONIAL LIST */}
                <div className="testimonial-list">
                    {loading ? (
                        <div>Loading...</div>
                    ) : testimonials.length > 0 ? (
                        testimonials.map((t) => (
                            <TestimonialCard key={t.id} {...t} />
                        ))
                    ) : (
                        <div>No testimonials available</div>
                    )}
                </div>

            </div>
        </div>
    );
}
